<template>
    <component
        v-bind="$attrs"
        :is="componentName"
        class="sbs-chip"
        :class="chipClasses"
    >
        <!-- @slot Слот для вставки контента перед Чипом (заменит содержимое props prepend) -->
        <slot name="prepend">
            {{ prepend }}
        </slot>

        <!-- @slot Слот по-умолчанию для вставки контента Чипа (заменит содержимое props text) -->
        <slot>
            <span class="sbs-chip__text">
                {{ text }}
            </span>
        </slot>

        <!-- @slot Слот для вставки контента после Чипа (заменит содержимое props append) -->
        <slot name="append">
            {{ append }}
        </slot>
    </component>
</template>

<script>
import themesMixin from '../../mixins/themes.js';
import { AllColors } from '../../utils/colors.js';
import SbsBaseButton from '../button/SbsBaseButton.vue';

/**
 * Базовый компонент-чип, предназначенный для тегов/бейджов/счётчика
 */
export default {
    name: 'SbsChip',
    mixins: [themesMixin],
    computed: {
        componentName() {
            return this.clickable ? SbsBaseButton : 'div';
        },
        chipClasses() {
            return [
                ...this.themeClasses,
                {
                    clickable: this.clickable,
                },
            ];
        },
    },
    inheritAttrs: false,
    props: {
        /**
         * Контент, расположенный после чипа
         */
        append: {
            type: String,
            default: '',
        },
        /**
         * Тема (цветовые решения) для фона
         */
        // eslint-disable-next-line vue/no-unused-properties
        backgroundTheme: {
            type: String,
            default: AllColors.ADDITIONAL,
        },
        /**
         * Определяет будет ли чип кликабельным
         */
        clickable: {
            type: Boolean,
            default: false,
        },
        /**
         * Тема (цветовые решения) для цвета текста
         */
        // eslint-disable-next-line vue/no-unused-properties
        colorTheme: {
            type: String,
            default: AllColors.BLACK,
        },
        /**
         * Контент, расположенный до чипа
         */
        prepend: {
            type: String,
            default: '',
        },
        /**
         * Текст (контент) чипа
         */
        text: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss">
.sbs-chip {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding: 4px 10px;
    border-radius: $rounded-pill;

    @include typo-secondary-book;

    &.clickable {
        cursor: pointer;
    }
}
</style>
